import './Slider.less'
import Slider from './Slider'

export type { SliderValue } from './Slider'
export type { SliderProps } from './iSlider'

export default Slider
